import { useQuery } from "@tanstack/react-query";
import { fetchImmunizations } from "pages/patient/PatientImmunizationsPage/utils/fetchImmunizations";

// The patient's recorded immunisations, for rules that depend on what came before
// rather than on the product alone — PPV23's five-year window is the case in hand.
//
// Its own query key rather than the vaccine table's: that one carries a filter value in
// the key which does not affect the request, and the form has no business knowing about
// it. The cost is one extra fetch while the dialog is open, which is cheaper than two
// callers sharing a key that means different things to each.
export const usePatientImmunisationHistory = (patientId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["patientImmunisationHistory", tenantVal, patientId],
    queryFn: () => fetchImmunizations(tenantVal, patientId),
    enabled: !!tenantVal && !!patientId,
    staleTime: 60 * 1000,
  });
};
